module.exports = __webpack_public_path__ + "static/media/plus-cereja.e6786649.webp";